import { useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchSpeakersByIds } from '@/store/slices/speakers';
import { selectSpeakersById } from '@/store/slices/speakers/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';

const useLoadSpeakersByIds = (speakerIds: number[]) => {
  const channel = useAppSelector(getActiveChannel);
  const speakersById = useAppSelector(selectSpeakersById);

  const dispatch = useAppDispatch();

  const missingKey = useMemo(() => {
    return speakerIds
      .filter((id) => !speakersById[id])
      .sort((a, b) => a - b)
      .join(',');
  }, [speakersById, speakerIds]);

  useEffect(() => {
    if (!channel || !missingKey) return;

    dispatch(fetchSpeakersByIds({ channel, speakerIds: missingKey.split(',').map(Number) }));
  }, [channel, dispatch, missingKey]);
};

export default useLoadSpeakersByIds;
